/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';

/**
 * Generates a state variable with a reference associated to additionally to its setter.
 *
 * @param init The initial value of the state.
 * @returns Treble of [the state itself, setter of the state, reference of the state].
 */
export const useStateRef = <T>(init: T): [T, (newVal: T) => void, React.MutableRefObject<T>] => {
    const [state, setState] = React.useState<T>(init);
    const ref = React.useRef<T>(init);

    return [
        state,
        (newValue: T) => {
            ref.current = newValue;
            setState(newValue);
        },
        ref
    ];
};
